import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import RoleService from '@/core/services/role.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class EditRolesComponent extends Vue {

  roleService: any = new RoleService();
  sidebarService: any = new SidebarService();
  genericErr: any = [];
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  alias: string = "";
  permissions: any = [];
  aliases: any = {
    '^/.*$': 'Acceso ilimitado',
    '^/company.*$': 'Empresa',
    '^/business.*$': 'Giro',
    '^/role.*$': 'Roles',
    '^/user/admin.*$': 'Administradores',
    '^/user/candidate.*$': 'Candidatos',
    '^/question.*$': 'Preguntas',
    '^/section.*$': 'Secciones',
    '^/resource.*$': 'Recursos',
    '^/skill.*$': 'Competencias',
    '^/test/.*$': 'Reporte',
    '^/profile.*$': 'Perfiles',
    '^/support.*$': 'Soporte'
  };

  mounted (){
    const _ = this;
    _.getById();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  edit(){
    const _ = this;
    let role = {
      alias: _.alias,
      permissions: _.permissions
    };

    let idRole: any = location.href.split("/");
    idRole = idRole[5];
    _.isLoading = true;
    _.roleService.edit(role, idRole).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/roles');
      }, 1500)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getById(){
    const _ = this;
    let idRole: any = location.href.split("/");
    idRole = idRole[5];
    _.isLoading = true;
    _.roleService.getById(idRole).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.alias = data["data"].role.alias === 'candidate' ? 'evaluado' : data["data"].role.alias;
      _.permissions = data["data"].role.permissions;
      _.permissions.forEach(permission => {
        permission.alias = _.aliases[permission.endpoint];
      });
      console.log(_.permissions, 'ali2')

    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
        console.log(_.logInModal, '_.logInModal')
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  validations(alias = ''){
    const _ = this;
    _.genericErr = [];
    if(alias == ''){
      _.genericErr.push("Por favor escribe el nombre");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.edit()
  }
}
